import { useCallback, useEffect } from 'react';
export const useMouseOutside = (refs, handler, ev = true) => {
    const handleMouseOutside = useCallback((event) => {
        refs.length > 0 &&
            refs.forEach((ref) => {
                if (ref && !ref?.contains(event.target)) {
                    handler(event);
                }
                if (ref?.current && !ref?.current.contains(event.target)) {
                    handler(event);
                }
            });
    }, [handler, refs]);
    useEffect(() => {
        document.addEventListener('mousemove', handleMouseOutside, ev);
        return () => {
            document.removeEventListener('mousemove', handleMouseOutside, ev);
        };
    }, [ev, handleMouseOutside, handler, refs]);
};
//# sourceMappingURL=useMouseOutside.js.map